module.exports = __webpack_public_path__ + "static/media/header.5d0574da.png";